'use es6';

import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import { getAcademyUrlPublic, getCommunityUrlPublic, getKnowledgeBaseUrlPublic, getLanguagesUrlPublic, getMarketingUrlPublic, getOperationsSupportedApplicationsUrl, getOperationsUrlPublic, getProductAndServicesUrlPublic, getSalesUrlPublic, getServiceUrlPublic } from 'pricing-pages-lib/utils/publicPageUrls';
import * as ProductLines from 'self-service-api/constants/ProductLines';
export const FaqsConfig = {
  [ProductLines.MARKETING]: [{
    questionKey: 'marketing.whatIsMarketing411',
    href: getMarketingUrlPublic()
  }, {
    questionKey: 'marketing.whatAreMarketingContacts'
  }, {
    questionKey: 'marketing.howManyContacts411',
    onClick: () => {
      document.querySelector('#calculator').scrollIntoView({
        behavior: 'smooth'
      });
      getUsageTracker().track('scrollInteraction', {
        name: 'hub-subtitle',
        action: 'clicked calculate your price'
      });
    }
  }, {
    questionKey: 'marketing.howManyEmails411'
  }, {
    questionKey: 'marketing.requiredOnboarding411'
  }, {
    questionKey: 'marketing.whatSupport411',
    passedInOptions: {
      communityHref: getCommunityUrlPublic(),
      academyHref: getAcademyUrlPublic(),
      kbHref: getKnowledgeBaseUrlPublic(),
      langHref: getLanguagesUrlPublic(),
      onLinkClick: url => {
        getUsageTracker().track('externalLinkClick', {
          name: 'faq-click-link',
          url
        });
      }
    }
  }],
  [ProductLines.SALES]: [{
    questionKey: 'sales.whatIsSalesHub411',
    href: getSalesUrlPublic()
  }, {
    questionKey: 'sales.whatIsFreeVsPaid411'
  }, {
    questionKey: 'sales.howManyUsers411',
    onClick: () => {
      document.querySelector('#calculator').scrollIntoView({
        behavior: 'smooth'
      });
      getUsageTracker().track('scrollInteraction', {
        name: 'hub-subtitle',
        action: 'clicked calculate your price'
      });
    }
  }, {
    questionKey: 'sales.salesVsService411'
  }, {
    questionKey: 'sales.whatSupport411',
    passedInOptions: {
      communityHref: getCommunityUrlPublic(),
      academyHref: getAcademyUrlPublic(),
      kbHref: getKnowledgeBaseUrlPublic(),
      langHref: getLanguagesUrlPublic(),
      onLinkClick: url => {
        getUsageTracker().track('externalLinkClick', {
          name: 'faq-click-link',
          url
        });
      }
    }
  }],
  [ProductLines.SERVICE]: [{
    questionKey: 'service.whatIsServiceHub411',
    href: getServiceUrlPublic()
  }, {
    questionKey: 'service.whatIsFreeVsPaid411'
  }, {
    questionKey: 'service.howManyUsers411',
    onClick: () => {
      document.querySelector('#calculator').scrollIntoView({
        behavior: 'smooth'
      });
      getUsageTracker().track('scrollInteraction', {
        name: 'hub-subtitle',
        action: 'clicked calculate your price'
      });
    }
  }, {
    questionKey: 'service.salesVsService411'
  }, {
    questionKey: 'service.whatSupport411',
    passedInOptions: {
      communityHref: getCommunityUrlPublic(),
      academyHref: getAcademyUrlPublic(),
      kbHref: getKnowledgeBaseUrlPublic(),
      langHref: getLanguagesUrlPublic(),
      onLinkClick: url => {
        getUsageTracker().track('externalLinkClick', {
          name: 'faq-click-link',
          url
        });
      }
    }
  }],
  [ProductLines.CMS]: [{
    questionKey: 'cmsHub.whatIsCMSHub411',
    href: getMarketingUrlPublic()
  }, {
    questionKey: 'cmsHub.whatSupport411',
    passedInOptions: {
      communityHref: getCommunityUrlPublic(),
      academyHref: getAcademyUrlPublic(),
      kbHref: getKnowledgeBaseUrlPublic(),
      langHref: getLanguagesUrlPublic(),
      onLinkClick: url => {
        getUsageTracker().track('externalLinkClick', {
          name: 'faq-click-link',
          url
        });
      }
    }
  }, {
    questionKey: 'cmsHub.whatLimits411',
    href: getProductAndServicesUrlPublic()
  }],
  [ProductLines.OPERATIONS]: [{
    questionKey: 'operations.whatIsOperationsHub',
    href: getOperationsUrlPublic()
  }, {
    questionKey: 'operations.whatSupport',
    passedInOptions: {
      communityHref: getCommunityUrlPublic(),
      academyHref: getAcademyUrlPublic(),
      kbHref: getKnowledgeBaseUrlPublic(),
      langHref: getLanguagesUrlPublic(),
      onLinkClick: url => {
        getUsageTracker().track('externalLinkClick', {
          name: 'faq-click-link',
          url
        });
      }
    }
  }, {
    questionKey: 'operations.whatDoesDataSyncDo',
    isJSX: false
  }, {
    questionKey: 'operations.whatTypeOfDataSync',
    href: getOperationsSupportedApplicationsUrl()
  }, {
    questionKey: 'operations.whatApplicationsSync',
    href: getOperationsSupportedApplicationsUrl()
  }, {
    questionKey: 'operations.whatIsProgrammableAutomation',
    isJSX: false
  }],
  [ProductLines.MARKETING]: [{
    questionKey: 'marketing.whatIsMarketing411',
    href: getMarketingUrlPublic()
  }, {
    questionKey: 'marketing.whatAreMarketingContacts'
  }, {
    questionKey: 'marketing.howManyContacts411',
    onClick: () => {
      document.querySelector('#calculator').scrollIntoView({
        behavior: 'smooth'
      });
      getUsageTracker().track('scrollInteraction', {
        name: 'hub-subtitle',
        action: 'clicked calculate your price'
      });
    }
  }, {
    questionKey: 'marketing.howManyEmails411'
  }, {
    questionKey: 'marketing.requiredOnboarding411'
  }, {
    questionKey: 'marketing.whatSupport411',
    passedInOptions: {
      communityHref: getCommunityUrlPublic(),
      academyHref: getAcademyUrlPublic(),
      kbHref: getKnowledgeBaseUrlPublic(),
      langHref: getLanguagesUrlPublic(),
      onLinkClick: url => {
        getUsageTracker().track('externalLinkClick', {
          name: 'faq-click-link',
          url
        });
      }
    }
  }],
  [ProductLines.MARKETING]: [{
    questionKey: 'marketing.whatIsMarketing411',
    href: getMarketingUrlPublic()
  }, {
    questionKey: 'marketing.whatAreMarketingContacts'
  }, {
    questionKey: 'marketing.howManyContacts411',
    onClick: () => {
      document.querySelector('#calculator').scrollIntoView({
        behavior: 'smooth'
      });
      getUsageTracker().track('scrollInteraction', {
        name: 'hub-subtitle',
        action: 'clicked calculate your price'
      });
    }
  }, {
    questionKey: 'marketing.howManyEmails411'
  }, {
    questionKey: 'marketing.requiredOnboarding411'
  }, {
    questionKey: 'marketing.whatSupport411',
    passedInOptions: {
      communityHref: getCommunityUrlPublic(),
      academyHref: getAcademyUrlPublic(),
      kbHref: getKnowledgeBaseUrlPublic(),
      langHref: getLanguagesUrlPublic(),
      onLinkClick: url => {
        getUsageTracker().track('externalLinkClick', {
          name: 'faq-click-link',
          url
        });
      }
    }
  }],
  crm: [{
    questionKey: 'free.crmReallyFree411'
  }, {
    questionKey: 'free.whatAreLimits411',
    href: getProductAndServicesUrlPublic()
  }, {
    questionKey: 'free.emailIntegration411'
  }, {
    questionKey: 'free.whatIsAUser411'
  }, {
    questionKey: 'free.howManyContacts411'
  }, {
    questionKey: 'free.whatSupport411',
    passedInOptions: {
      communityHref: getCommunityUrlPublic(),
      academyHref: getAcademyUrlPublic(),
      kbHref: getKnowledgeBaseUrlPublic(),
      langHref: getLanguagesUrlPublic(),
      onLinkClick: url => {
        getUsageTracker().track('externalLinkClick', {
          name: 'faq-click-link',
          url
        });
      }
    }
  }],
  suite: [{
    questionKey: 'crmSuite.whatIsCrmSuite',
    onClick: () => {
      document.querySelector('#calculator').scrollIntoView({
        behavior: 'smooth'
      });
      getUsageTracker().track('scrollInteraction', {
        name: 'hub-subtitle',
        action: 'clicked calculate your price'
      });
    }
  }]
};